import React from 'react';
import styles from './css/Item.styl';

const Item = props => (
  /**
   * Returns JSX representation of a Reason block
   * @param {Object} icon icon
   * @param {String} title reason title
   * @param {String} blurb reason text
   * @returns {JSX} Reason block
   */
  <div className={styles.Item}>
    <div className={styles.IconContainer}>{props.icon}</div>
    <div className={styles.TextContainer}>
      <div className={styles.ItemTitle}>{props.title}</div>
      <div className={styles.ItemBlurb}>{props.blurb}</div>
    </div>
  </div>
);

Item.propTypes = {
  blurb: React.PropTypes.string,
  icon: React.PropTypes.object,
  title: React.PropTypes.string,
};

export default Item;



// WEBPACK FOOTER //
// ./src/reactModules/pages/GeneralPlanning/components/WhatsIncluded/Item.js